import { render, staticRenderFns } from "./FPTemp3.vue?vue&type=template&id=2638185c&scoped=true&"
import script from "./FPTemp3.vue?vue&type=script&lang=js&"
export * from "./FPTemp3.vue?vue&type=script&lang=js&"
import style0 from "./FPTemp3.vue?vue&type=style&index=0&id=2638185c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2638185c",
  null
  
)

export default component.exports